function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_316",
  "data-name": "Group 316",
  transform: "translate(-637.701 -247.358)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_342",
  "data-name": "Path 342",
  d: "M655.112,257.713a7.48,7.48,0,1,1-7.466-7.011",
  transform: "translate(-1.091 0.677)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_294",
  "data-name": "Group 294",
  transform: "translate(648.241 247.901)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_343",
  "data-name": "Path 343",
  d: "M652.237,254.041a8.873,8.873,0,0,1-2.4,1.463",
  transform: "translate(-644.247 -246.865)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_344",
  "data-name": "Path 344",
  d: "M649.834,250.455c1.22-1.4,3.286-2.253,4.806-.73,1.649,1.653.541,3.239-.528,4.32",
  transform: "translate(-644.247 -248.895)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_345",
  "data-name": "Path 345",
  d: "M651.61,250.46a5.16,5.16,0,0,0-1.635-1.262,2.708,2.708,0,0,0-3.324.687c-1.756,1.97.569,4.512,2.107,5.824a9.588,9.588,0,0,0,2.852,1.83",
  transform: "translate(-646.024 -248.901)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_346",
  "data-name": "Path 346",
  d: "M657.021,264.786c-1.831-1.525-4.539-2.609-8.54-2.609s-6.709,1.084-8.54,2.609",
  transform: "translate(-1.536 6.115)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

var SvgJoratoInterests = function SvgJoratoInterests(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.284,
    height: 24.247,
    viewBox: "0 0 22.284 24.247",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoInterests, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-interests.e1379a1f.svg";
export { ForwardRef as ReactComponent };